export default __webpack_public_path__ + "static/media/home-new.fb9ba0b0.svg";